import React from 'react';
import router from 'yofobasement/router';
import { SafeAreaView as NativeSafeAreaView } from 'react-native-view';
import { isWeapp } from 'yofobasement/utils/runtime';
import { queryStringToObj } from 'yofobasement/utils/router';

export const withNavigation = (Component) => {
  return (props) => {
    const getRouterParams = () => {
      if (isWeapp()) {
        const pages = getCurrentPages();
        const currentPage = pages[pages.length - 1]; // 获取当前页面实例
        return currentPage.options;
      } else {
        const params = location.href.split('?')[1];
        return queryStringToObj(params);
      }
    };
    const pushRouter = (routerName, params = {}) => {
      router.push(routerName, params);
    };
    const replaceRouter = (routerName, params = {}) => {
      router.replace(routerName, params);
    };

    const navigation = {
      replace: replaceRouter,
      navigate: pushRouter,
      push: pushRouter,
      state: {
        params: getRouterParams()
      },
      addListener: () => {
        console.log('addListener');
      }
    };
    return <Component {...props} navigation={navigation} />;
  };
};
export const StackActions = () => {};
export const NavigationActions = () => {};
export const SafeAreaView = (props) => <NativeSafeAreaView>{props.children}</NativeSafeAreaView>;
export default {
  withNavigation: withNavigation,
  StackActions: StackActions,
  NavigationActions: NavigationActions
};



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/external/react-navigation/index.js